// extracted by mini-css-extract-plugin
export default {"scrollButton":"no-purify__scrollButton__scrollButton___LSR4Y","arrow":"no-purify__scrollButton__arrow___wqxnf"};